import {
    editRenewal,
    getAllRenewals,
    getRenewal
} from "../../config/config";
import { toast } from "react-toastify";
export const API_REQUEST = "API_REQUEST";

export const SET_RENEWAL_FILTERS = "SET_RENEWAL_FILTERS";

export const GET_ALL_RENEWALS = "GET_ALL_RENEWALS"
export const GET_ALL_RENEWALS_SUCCESS = "GET_ALL_RENEWALS_SUCCESS"

export const GET_RENEWAL = "GET_RENEWAL"
export const GET_RENEWAL_SUCCESS = "GET_RENEWAL_SUCCESS"

export const GET_ALL_RENEWALS_FILTER = "GET_ALL_RENEWALS_FILTER"
export const GET_ALL_RENEWALS_FILTER_SUCCESS = "GET_ALL_RENEWALS_FILTER_SUCCESS"

export const EDIT_RENEWAL = "EDIT_RENEWAL"
export const EDIT_RENEWAL_SUCCESS = "EDIT_RENEWAL_SUCCESS"

export const CHANGE_PAGE = "CHANGE_PAGE"

export const SET_VIEW ='SET_VIEW'
//GET RENEWAL
const getRenewals = (page, limit, filters, loading, setPage, setFailedPage, view, dispatch) => {
    console.log(loading)
    if (loading)
        dispatch({
            type: GET_ALL_RENEWALS_FILTER,
            payload: {
                getRenewalsFilterLoading: true
            },
        });
    else
        dispatch({
            type: GET_ALL_RENEWALS,
            payload: {
                getRenewalsLoading: true
            },
        });
    getAllRenewals(page, limit, filters).then((res) => {

        if (loading)
            dispatch({
                type: GET_ALL_RENEWALS_FILTER,
                payload: {
                    getRenewalsFilterLoading: false
                },
            });
        else
            dispatch({
                type: GET_ALL_RENEWALS,
                payload: {
                    getRenewalsLoading: false
                },
            });
        if (res?.status === 200) {

            if (typeof setPage === 'function' && view) {
                setPage(page + 1);
            }
            if (typeof setPage === 'function' && !view) {
                setPage();
            }
            dispatch({
                type: "SET_PAGE_DETAILS",
                payload: {
                    page: "renewals",
                    currentPage: res?.data?.currentPage,
                    totalPages: res?.data?.totalPages,
                    totalRecords: res?.data?.totalRecords
                },
            });
            dispatch({
                type: GET_ALL_RENEWALS_FILTER_SUCCESS,
                payload: {
                    renewals: res?.data?.data,
                    page: res?.data?.currentPage,
                    totalPages: res?.data?.totalPages,
                    totalRecords: res?.data?.totalRecords,
                    view,
                },
            });
        } else if (res?.status === 401) {
            window.location = "/session-ended";
        } else if (res?.status === 403) {
            window.location = "/forbidden";
        } else {
            toast.error(res?.data?.message || "error", { theme: "colored" });
        }
    }).catch(() => {
        if (typeof setFailedPage === 'function') {
            setFailedPage(page)
        }
    });
}

const actions = {

    setView: (data) => (dispatch) => {
        dispatch({ type: SET_VIEW, payload: { view: data } })
    },
    changePage: (data, flag = false) => (dispatch) => {

        dispatch({ type: CHANGE_PAGE, payload: { page: data, flag: flag } })
    },
    //FETCH ALL RENEWALS
    getAllRenewals: (page, limit, filters, loading, setPage, setFailedPage = null, view) => (dispatch) => {
        getRenewals(page, limit, filters, loading, setPage, setFailedPage, view, dispatch)
    },
    //EDIT RENEWAL
    editRenewal: (data, id, history) => (dispatch) => {
        dispatch({
            type: EDIT_RENEWAL,
            payload: {
                editRenewalLoading: true,
            },
        });

        editRenewal(data, id).then((res) => {
            dispatch({
                type: EDIT_RENEWAL,
                payload: {
                    editRenewalLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: EDIT_RENEWAL_SUCCESS,
                    payload: {
                        editedRenewal: res?.data?.editedRenewal
                    },
                });

                toast.success(res?.data?.message || "Success", { theme: "colored" });
            } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },
    //GET RENEWAL
    getRenewal: (id,filters) => (dispatch) => {
        dispatch({
            type: GET_RENEWAL,
            payload: {
                getRenewalLoading: true,
            },
        });

        getRenewal( id,filters).then((res) => {
            dispatch({
                type: GET_RENEWAL,
                payload: {
                    getRenewalLoading: false,
                },
            });

            if (res?.status === 200) {
                dispatch({
                    type: GET_RENEWAL_SUCCESS,
                    payload: {
                       currentRenewal: res?.data?.data
                    },
                });

          } else if (res?.status === 401) {
                window.location = "/session-ended";
            } else if (res?.status === 403) {
                window.location = "/forbidden";
            } else {
                toast.error(res?.data?.message || "error", { theme: "colored" });
            }
        });
    },

};

export default actions;
